import React, { useMemo } from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import DashboardCommissionCard from '../DashboardCommissionCard';
import PoundFormat from '../../lib/strings/poundFormat';
import useCommission from '€hooks/useCommission';
import { getCurrentMonth, getCurrentYear } from '€lib/dates/getLast';

const DashboardCommission: React.FC = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const { thisMonthsAmount, thisYearsAmount, monthlyPercentage, annualPercentage } =
        useCommission();
    const currentMonth = useMemo(() => getCurrentMonth(), []);
    const currentYear = useMemo(() => getCurrentYear(), []);
    const monthlyComparison = monthlyPercentage ? `vs LM ${monthlyPercentage}` : '';
    const annualComparison = annualPercentage ? `vs LY ${annualPercentage}` : '';

    return (
        <Box>
            <Box
                display="flex"
                flexDirection={{ xs: 'column', smDown: 'column', md: 'row' }}
                width="100%"
                justifyContent={{ sm: 'center', md: 'space-between' }}
            >
                <DashboardCommissionCard
                    title={`${matches ? 'Month to Date' : 'MTD'}`}
                    amount={PoundFormat(thisMonthsAmount, true)}
                    comparison={monthlyComparison}
                    lastCalculated={`${currentMonth} ${currentYear}`}
                />
                <DashboardCommissionCard
                    title={`${matches ? 'Year to Date' : 'YTD'}`}
                    amount={PoundFormat(thisYearsAmount, true)}
                    comparison={annualComparison}
                    lastCalculated={currentYear}
                />
            </Box>
        </Box>
    );
};

export default DashboardCommission;
